const SESSION_COOKIE_NAME = 'via-session-id';
const LANG_COOKIE_NAME = 'via-lang';

function getCookie(name) {
  const cookie = {};
  document.cookie.split(';').forEach((el) => {
    const [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });
  return cookie[name];
}

function getSessionCookie() {
  return getCookie(SESSION_COOKIE_NAME);
}

export function getLanguageCookie() {
  return getCookie(LANG_COOKIE_NAME);
}

export function setLanguageCookie(locale) {
  document.cookie = `${LANG_COOKIE_NAME}=${locale}`;
}


export { getCookie, getSessionCookie, SESSION_COOKIE_NAME };
